module.exports = __webpack_public_path__ + "media/components/country-flag/static/gb-eng-f6df637c5a47b4b63b363cb4fce6116d.svg";